import React, { useEffect } from "react";
import ReactGA from "react-ga4";

// components
// import Navbar from "../components/navbar/Navbar";
import IrHeader from "../components/investor-relations/IrHeader";
import IrPressReleases from "../components/investor-relations/IrPressReleases";
// import CommunicationsHeader from "../components/investor-relations/CommunicationsHeader";
// import CommunicationsCards from "../components/investor-relations/CommunicationsCards";
import Communications from "../components/investor-relations/Communications";
import SecFilings from "../components/investor-relations/SecFilings";
// import PrePreFooter from "../components/pre-footer/PrePreFooter";
import PreFooter from "../components/pre-footer/PreFooter";
import Footer from "../components/footer/Footer";

const InvestorRelationsWrapper = () => {
  useEffect(() => {
    const currentPage = window.location.pathname;
    ReactGA.send({
      hitType: "pageview",
      page: "/investorrelations",
      title: "investor relations",
    });
    // console.log("GA Page View Sent:", currentPage); // Debugging
  }, []);
  return (
    <>
      {/* <Navbar /> */}
      <IrHeader />
      <IrPressReleases />
      <SecFilings />
      <Communications />
      {/* <CommunicationsHeader />
      <CommunicationsCards /> */}
      {/* <PrePreFooter></PrePreFooter> */}
      <PreFooter />
      <Footer />
    </>
  );
};

export default InvestorRelationsWrapper;
